// View model of the directory card's system-computed facts: the reply time,
// which only directory items (GET /circles) carry.
// The leader-entered place, format and language ride every GroupSummary and
// live on `CircleSummary`.
import type { components } from '@leanin/api-client';

type RankedCircleSummary = components['schemas']['RankedCircleSummary'];
type CircleCardFacts = components['schemas']['CircleCardFacts'];

export interface CircleCardFactsView {
  readonly replies: CircleCardFacts['replies'];
}

export function cardFactsView(g: RankedCircleSummary): CircleCardFactsView {
  return {
    replies: g.facts.replies,
  };
}

export function languageLabel(code: string, locale: string): string {
  try {
    return new Intl.DisplayNames([locale], { type: 'language', fallback: 'code' }).of(code) ?? code;
  } catch (error) {
    // Writes are validated against the shared LanguageTagSchema, but rows
    // stored before that boundary existed may hold a tag Intl rejects; show
    // those verbatim rather than crash the directory.
    if (error instanceof RangeError) return code;
    throw error;
  }
}
